import React from 'react';
import Alert, {AlertProps} from '@material-ui/lab/Alert';
import Skeleton, {SkeletonProps} from '@material-ui/lab/Skeleton';

export interface AlertSkeletonProps {
    AlertProps?: AlertProps;
    SkeletonProps?: SkeletonProps;
}

//NOTE: do NOT change default props, just pass overriding props for customizations
const AlertSkeleton: React.FC<AlertSkeletonProps> = ({AlertProps, SkeletonProps}) => (
    <Alert severity="warning" variant="standard" style={{alignItems: 'center'}} {...AlertProps}>
        <Skeleton height={60} {...SkeletonProps} />
    </Alert>
);

export default AlertSkeleton;
